
































































import { ActionTypeEnum } from '@empathybroker/tsclient-play/dist/enums/action-type.enum';
import { SynonymTypeConfig } from '@empathybroker/tsclient-play/dist/models/instance/synonym-type-config';

import Vue from 'vue';

import { AlignEnum } from '../../../enums';

import DataTable from '../../crud/data-table.component.vue';
import EditableLabel from '../../editable-label.component.vue';
import { UiButton, UiIconButton, UiTextbox } from '../../keen-ui';

export default {
  name: 'synonyms-config-form',
  props: {
    toolConfig: {
      type: Object,
      required: true
    },
    instance: {
      type: Object,
      required: true
    }
  },
  components: {
    UiTextbox,
    UiButton,
    DataTable,
    EditableLabel,
    UiIconButton
  },
  computed: {
    actionIconButtonProps: function () {
      return {
        size: 'mini',
        type: 'secondary'
      };
    }
  },
  data: function () {
    const messages = this.$epb.messages.tools.instances.fields.tools[ActionTypeEnum.SYNONYM].fields;
    return {
      creationType: {},
      editionType: {},
      typeColumns: [
        {
          id: 'id',
          text: messages.types.id.label
        },
        {
          id: 'prettyName',
          text: messages.types.prettyName.label
        },
        {
          id: 'actions',
          align: AlignEnum.CENTER,
          width: '10rem'
        }
      ],
      messages: messages
    };
  },
  methods: {
    isTypeSelected: function (typeId: string): boolean {
      return (typeId === this.editionType.originalId);
    },
    isTypeValid: function (type, ignoreSelectedType?: boolean): boolean {
      return this.isTypeIdValid(type.id, ignoreSelectedType);
    },
    isTypeIdValid: function (typeId: string, ignoreSelectedType?: boolean): boolean {
      if (!typeId) {
        return false;
      } else {
        return !this.toolConfig.types.some((synonymType: SynonymTypeConfig) => {
          return ((synonymType.id === typeId) && !(ignoreSelectedType && this.isTypeSelected(synonymType.id)));
        });
      }
    },
    onAddTypeClick: function (): void {
      if (this.isTypeValid(this.creationType)) {
        this.toolConfig.types.push(this.creationType);
        this.creationType = {};
      }
    },
    setEditionTypeProperty: function (typeProperty: string, value: string): void {
      Vue.set(this.editionType, typeProperty, value);
    },
    isTypeEditionDisabled: function (typeId: string): boolean {
      return (this.isTypeSelected(typeId) && !this.isTypeValid(this.editionType, true)) ||
        (!this.isTypeSelected(typeId) && !!this.editionType.originalId);
    },
    onEditTypeClick: function (type: SynonymTypeConfig): void {
      if (!this.isTypeSelected(type.id)) {
        this.editionType = { ...type, originalId: type.id };
      } else if (this.isTypeValid(this.editionType, true)) {
        const selectedType = this.toolConfig.types.find((configType: SynonymTypeConfig) =>
          configType.id === this.editionType.originalId);
        Object.assign(selectedType, { id: this.editionType.id, prettyName: this.editionType.prettyName });
        this.editionType = {};
      }
    },
    onDeleteTypeClick: function (typeId: string): void {
      const synonymTypeIndex = this.toolConfig.types.findIndex((type: SynonymTypeConfig) => type.id === typeId);
      this.toolConfig.types.splice(synonymTypeIndex, 1);
      this.editionType = {};
    }
  }
};
